export default __webpack_public_path__ + "static/sanofi-min-92333ad5e2e7c33f00f2a619a4943ba1.jpg";